import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { OnlineProfileModal } from "./OnlineProfileModal";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";

export const OnlineProfiles = ({
  onlineProfileList,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [onlineProfileModal, setShowOnlineProfileModal] = useState(false);
  const [selecrtedOnlineProfile, setSelectedOnlineProfile] = useState(null);

  const toggleOnlineProfileModal = (onprofile) => {
    setShowOnlineProfileModal((prev) => !prev);
    if (onprofile) {
      setSelectedOnlineProfile(onprofile);
    } else {
      setSelectedOnlineProfile(null);
    }
  };

  const handleDeleteOnlineProfile = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.onlineProfiles,
        [VIEW_PROFILE_SECTIONS.onlineProfiles]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.onlineProfiles")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleOnlineProfileModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addOnlineProfile")}
              </button>
            </div>
          )}
        </div>
        <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-3">
          {onlineProfileList && onlineProfileList.length > 0 ? (
            onlineProfileList.map((onprofile, idx) => (
              <li key={idx.toString()}>
                <div className="d-flex flex-column row-gap-0">
                  <div className="d-flex gap-3">
                    <h5 className="mb-0 text-base font-semibold text-grey-800">
                      {onprofile.platform}
                    </h5>
                    {isCurrentUserProfile && (
                      <div className="ms-auto d-flex align-items-center gap-3">
                        <Button
                          variant="link"
                          className="p-0 text-base text-grey-600 text-decoration-none"
                          onClick={() => toggleOnlineProfileModal(onprofile)}
                        >
                          <i className="bx bx-pencil"></i>
                        </Button>
                        <Button
                          variant="link"
                          className="p-0 text-base text-grey-600 text-decoration-none"
                          onClick={() =>
                            handleDeleteOnlineProfile(onprofile.gid)
                          }
                        >
                          <i className="bx bx-trash"></i>
                        </Button>
                      </div>
                    )}
                  </div>
                  <a
                    href={onprofile.profileUrl}
                    target="_blank"
                    className="text-medium"
                  >
                    {onprofile.profileUrl}
                  </a>
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noOnlineProfile")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {onlineProfileModal && (
        <OnlineProfileModal
          show={onlineProfileModal}
          onlineProfileData={selecrtedOnlineProfile}
          toggle={toggleOnlineProfileModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
